module.exports = __webpack_public_path__ + "img/mgu-1.ab3be09.jpg";